/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Tabs as DesignTabs } from '@whalecloud/fdx';
import { useHandler } from "@whalecloud/page-builder-core/hooks/useHandler";
import isEqual from "lodash/isEqual";
import Element from '@whalecloud/page-builder-core/components/Element';
import { set } from 'dot-prop-immutable';
import { getElementWithChildren } from '@whalecloud/page-builder-core/selectors';
import ConnectedSlate from "@whalecloud/page-builder-core/components/Slate";
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const { TabPane } = DesignTabs;

const TabsElement = (props) => {
  const {
    elementStyle,
    elementAttributes,
    customClasses,
    combineClassNames,
    element,
  } = props;

  const { elements, data: { formItemSettings = {}, formSettings = {}, settings = {}, className = '' } } = element;
  const { visible } = settings;
  const { tabs = [], defaultActiveKey, ...restProps } = formItemSettings;
  const contentElements = elements.slice(0, tabs.length);

  const defaultKey = defaultActiveKey || contentElements[0].id;
  const [activeKey, setActiveKey] = useState(defaultKey)

  const onChange = useHandler(props, ({ element, updateElement }) => (value, index, titleArr) => {
    if (value !== titleArr[index].text) {
      const temp = titleArr;
      temp[index] = {
        ...temp[index],
        text: value
      }
      updateElement({ element: set(element, 'data.formItemSettings.tabs', [...temp]), merge: true });
    }
  });

  const renderTitle = useCallback(
    (index: number) => {
      const item = tabs[index];
      return <ConnectedSlate value={item.text ? item.text : item} onChange={(value) => { onChange(value, index, tabs) }} />;
    }, [tabs]
  );

  const handleChange = activeKey => {
    setActiveKey(activeKey);
  }

  useEffect(() => {
    if (defaultActiveKey) {
      setActiveKey(defaultActiveKey);
    }
  }, [defaultActiveKey]);

  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <div
        className={combineClassNames('webiny-pb-layout-tabs webiny-pb-base-page-element-style', ...customClasses)}
        {...elementAttributes}
      >
        <DesignTabs
          defaultActiveKey={defaultKey}
          activeKey={activeKey}
          onChange={handleChange}
          {...restProps}
          className={className}
        >
          {
            contentElements.map((child, i) => (
              <TabPane
                key={child.id}
                tab={renderTitle(i)}
              >
                <Element id={child.id} />
              </TabPane>
            ))
          }
        </DesignTabs>
      </div>
    </FormItem>
  );
};

export default connect<any, any, any>(
  (state, props) => {
    const element = getElementWithChildren(state, props.elementId);
    return { element: { ...element } }
  },
  null,
  null,
  {
    areStatePropsEqual: isEqual,
  })(React.memo(TabsElement));
